// FQ-065 — the cancellation reason / date shown next to the "בוטל" badge on a
// project / engagement header (P-02c, Q-P6). Pure, so it is unit-tested.
export interface CancellationSource {
  status?: string | null;
  cancellation_reason?: string | null;
  cancelled_at?: string | null;
}

export interface CancellationNoteData {
  reason: string | null;
  cancelledAt: string | null;
}

/** null unless the record is cancelled and carries a reason or a date. */
export function cancellationNoteData(src: CancellationSource | null | undefined): CancellationNoteData | null {
  if (!src || src.status !== 'cancelled') return null;
  const reason = typeof src.cancellation_reason === 'string' && src.cancellation_reason.trim()
    ? src.cancellation_reason.trim()
    : null;
  const cancelledAt = src.cancelled_at || null;
  if (!reason && !cancelledAt) return null;
  return { reason, cancelledAt };
}
